import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'sonner';
import './App.css';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { LanguageProvider } from './contexts/LanguageContext';
import ProtectedRoute from './components/ProtectedRoute';
import AppShell from './components/AppShell';
import LoginPage from './pages/Login';
import DashboardPage from './pages/Dashboard';
import OrdersPage from './pages/Orders';
import SettlementsPage from './pages/Settlements';
import SettlementDetailPage from './pages/SettlementDetail';
import ManualReviewPage from './pages/ManualReview';
import DuplicateCustomersPage from './pages/DuplicateCustomers';
import ClearingHealthPage from './pages/ClearingHealth';
import DepositosPage from './pages/Depositos';
import DepositoDetailPage from './pages/DepositoDetail';
import LogsPage from './pages/Logs';
import ConfigPage from './pages/Config';
import HealthStatusPage from './pages/HealthStatus';
import IntegrationsPage from './pages/Integrations';
import EulaPage from './pages/Eula';
import PrivacyPage from './pages/Privacy';
import NewCustomersPage from './pages/NewCustomers';
// Fix 52 (2026-10-07): Reportes de ventas (clientes y ventas por estado).
import SalesReportsPage from './pages/SalesReports';
// Fix 51 (2026-10-06): pantalla Agenda iCloud (solo admin).
import AgendaPage from './pages/Agenda';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30 * 1000, refetchOnWindowFocus: false, retry: 1 },
  },
});

export default function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/login" element={<LoginPage />} />
                <Route path="/eula" element={<EulaPage />} />
                <Route path="/privacy" element={<PrivacyPage />} />
                <Route
                  path="/"
                  element={
                    <ProtectedRoute>
                      <AppShell />
                    </ProtectedRoute>
                  }
                >
                  <Route index element={<Navigate to="/dashboard" replace />} />
                  <Route path="dashboard" element={<DashboardPage />} />
                  <Route path="orders" element={<OrdersPage />} />
                  <Route path="new-customers" element={<NewCustomersPage />} />
                  <Route path="sales-reports" element={<SalesReportsPage />} />
                  <Route path="agenda" element={<AgendaPage />} />
                  <Route path="settlements" element={<SettlementsPage />} />
                  <Route path="settlements/:settlementId" element={<SettlementDetailPage />} />
                  <Route path="manual-review" element={<ManualReviewPage />} />
                  <Route path="duplicate-customers" element={<DuplicateCustomersPage />} />
                  <Route path="clearing" element={<ClearingHealthPage />} />
                  <Route path="depositos" element={<DepositosPage />} />
                  <Route path="depositos/:payoutId" element={<DepositoDetailPage />} />
                  <Route path="logs" element={<LogsPage />} />
                  <Route path="config" element={<ConfigPage />} />
                  <Route path="integrations" element={<IntegrationsPage />} />
                  <Route path="health" element={<HealthStatusPage />} />
                </Route>
                <Route path="*" element={<Navigate to="/dashboard" replace />} />
              </Routes>
              <Toaster position="top-right" richColors closeButton />
            </BrowserRouter>
          </AuthProvider>
        </QueryClientProvider>
      </LanguageProvider>
    </ThemeProvider>
  );
}
